import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { getHistoryForm } from '../api';
import { StudentsRemovalRequestHistoryFiltersResponse } from '../types/history';

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  StudentsRemovalRequestHistoryFiltersResponse,
  AxiosResultDefaultError
>();

export const useStudentsRemovalRequestHistoryFilters = useFetch;

export function StudentsRemovalRequestHistoryFiltersConsumer({
  children,
}: {
  children: (args: {
    data: StudentsRemovalRequestHistoryFiltersResponse;
  }) => ReactElement;
}) {
  return (
    <FetchConsumer>
      {({ data, error, loading, refresh }) => {
        if (error) {
          return (
            <DisplayError
              insideCard
              textBody={error.code}
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }
        if (loading) {
          return <Loading insideCard />;
        }

        if (!data) {
          return (
            <DisplayError
              insideCard
              textBody="Data no cargada"
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        return children({ data });
      }}
    </FetchConsumer>
  );
}

export function StudentsRemovalRequestHistoryFiltersLoader({
  children,
}: {
  children: (args: {
    data: StudentsRemovalRequestHistoryFiltersResponse;
  }) => ReactElement;
}) {
  const request = useCallback(async () => {
    return getHistoryForm();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <StudentsRemovalRequestHistoryFiltersConsumer>
        {({ data }) => children({ data })}
      </StudentsRemovalRequestHistoryFiltersConsumer>
    </FetchProvider>
  );
}
